export { default } from "./PrintAssignment";
